// @flow
import { omit } from 'lodash';

import { LOGOUT } from '@screens/SignIn/redux/constants';

import {
  PERSONAL_DATA_REQUEST,
  PERSONAL_DATA_REQUESTED_ERROR,
  PERSONAL_DATA_REQUESTED_SUCCESS,
  PERSONAL_DATA_FORM_ERROR,
  PERSONAL_DATA_FORM_SUCCESS,
  PERSONAL_DATA_FORM_UPDATE,
  PERSONAL_DATA_FORM_RESET,
  PERSONAL_DATA_FIRST_LOAD
} from './constants';

import type { Action, State } from './types';
import parseData from './utils';

const initialState: State = {
  data: null,
  opinion: null,
  getStatus: {
    requesting: false,
    error: null
  },
  updateStatus: {
    requesting: [],
    error: {}
  },
  isFirstLoad: true
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case PERSONAL_DATA_REQUEST: {
      return {
        ...state,
        getStatus: {
          requesting: true,
          error: null
        }
      };
    }
    case PERSONAL_DATA_REQUESTED_SUCCESS: {
      return {
        ...state,
        data: action.data ? parseData(action.data) : {},
        getStatus: {
          requesting: false,
          error: null
        }
      };
    }
    case PERSONAL_DATA_REQUESTED_ERROR: {
      return {
        ...state,
        getStatus: {
          requesting: false,
          error: action.error
        }
      };
    }
    case PERSONAL_DATA_FORM_UPDATE:
      return {
        ...state,
        updateStatus: {
          ...state.updateStatus,
          requesting: [...state.updateStatus.requesting, action.id]
        }
      };
    case PERSONAL_DATA_FORM_ERROR: {
      return {
        ...state,
        updateStatus: {
          requesting: state.updateStatus.requesting.filter(v => v !== action.id),
          error: {
            ...state.updateStatus.error,
            [action.id]: action.error
          }
        }
      };
    }
    case PERSONAL_DATA_FORM_SUCCESS: {
      return {
        ...state,
        updateStatus: {
          requesting: state.updateStatus.requesting.filter(v => v !== action.id),
          error: omit(state.updateStatus.error, action.id)
        }
      };
    }
    case PERSONAL_DATA_FORM_RESET: {
      return {
        ...state,
        getStatus: {
          ...state.getStatus,
          error: null
        },
        updateStatus: {
          ...state.updateStatus,
          error: omit(state.updateStatus.error, action.id)
        }
      };
    }
    case PERSONAL_DATA_FIRST_LOAD: {
      return {
        ...state,
        isFirstLoad: false
      };
    }
    case LOGOUT:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default reducer;
